export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-mail-92d5594a8a51c5aeff190566f1de3db2.svg";